import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const DesktopService = () => {
  // const linkClass =
  //   "flex justify-between px-3 items-center  py-2 rounded font-medium text-gray-800 no-underline  hover:text-main transition-colors duration-300";

  //   const linkClass = `
  //   relative flex justify-between px-3 items-center py-2 rounded font-medium
  //   text-gray-800 no-underline hover:text-main transition-colors duration-300
  //   before:content-[''] before:absolute before:left-0 before:bottom-0
  //   before:h-[2px] before:w-0 before:bg-main before:transition-all
  //   before:duration-300 hover:before:w-full
  // `;
  const linkClass = `
  flex justify-between items-center px-3 py-2  font-medium
  text-gray-800 no-underline transition-colors duration-300
  hover:bg-main hover:text-white
`;

  const Services = [
    { name: "Web Solution", path: "/web-solution" },
    {
      name: "Content Management System",
      path: "/content-management-system",
    },
    { name: "E-Commerce", path: "/e-commerce-services" },
    {
      name: "CRM SCM and ERP Services",
      path: "/crm-scm-and-erp-services",
    },

    { name: "Mobile Application", path: "/mobile-application-services" },
    {
      name: "SEO Services",
      path: "/seo-services",
    },
    {
      name: "Application Migration",
      path: "/application-migration",
    },
    {
      name: "Technical Maintenance",
      path: "/technical-maintenance-services",
    },
    {
      name: "EAI service",
      path: "/eai-services",
    },
  ];

  return (
    <>
      <div className="w-[300px] bg-white  shadow-2xl  text-sm text-gray-800">
        <ul className=" pl-0 text-[15px] ">
          {Services.map((item) => (
            <li key={item.path}>
              <Link to={item.path} className={linkClass}>
                <span>{item.name}</span>
                <FontAwesomeIcon icon={faArrowRight} />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default DesktopService;
